import { type PaginationParams } from '@webapp/core/providers/Pagination/pagination.types'
import { type RepoFilterParams } from '@webapp/infrastructure/interfaces/repositories/RepoFilterParams'
import { type Permission, type User } from '@webapp/platform/iam/entities'

// Plain array literals (not buildQueryKey) because parts can be undefined at
// runtime; buildQueryKey would truncate the key at the first undefined element
// and change the resulting query key.
export const primaryCategoryQueryConfig = {
  byPermissionAndUser: ({
    permissionId,
    userAuthId,
  }: {
    permissionId: Permission['id']
    userAuthId: User['authId']
  }) => ({
    queryKey: ['primary-category-list', permissionId, userAuthId],
  }),
  list: ({
    paginationParams,
    params,
  }: {
    paginationParams: PaginationParams
    params?: Omit<RepoFilterParams, 'pageSize'> & { pageSize?: number | 'all' }
  }) => ({
    queryKey: ['primary-category', paginationParams, params],
  }),
}
